import React from 'react';
import { useTranslation } from 'react-i18next';
import logo from '../assets/log.png';

type Props = {
    children: React.ReactNode;
};

const styles = {
    page: {
        height: '100%',
        display: 'flex',
        alignItems: 'stretch',
        backgroundColor: '#fff',
    } as React.CSSProperties,
    sidebar: {
        flex: '0 0 35%',
        maxWidth: '35%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem 1.5rem',
        gap: '1.25rem',
    } as React.CSSProperties,
    logo: {
        width: '100%',
        height: 'auto',
        maxHeight: '60vh',
        objectFit: 'contain',
    } as React.CSSProperties,
    tagline: {
        textAlign: 'center',
        color: '#7a8a9a',
        fontSize: '1.1rem',
        margin: 0,
    } as React.CSSProperties,
    content: {
        flex: '1 1 0',
        minWidth: 0,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
        padding: '2rem 1.5rem',
    } as React.CSSProperties,
    contentInner: {
        margin: 'auto',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    } as React.CSSProperties,
};

const mediaCss = `
@media (max-width: 991.98px) {
    .constellation-layout {
        flex-direction: column;
    }
    .constellation-layout__sidebar {
        flex: 0 0 auto !important;
        max-width: 100% !important;
        padding: 1.5rem 1rem 0.5rem !important;
    }
    .constellation-layout__logo {
        max-width: 220px !important;
        max-height: none !important;
    }
    .constellation-layout__tagline {
        font-size: 0.9rem !important;
    }
    .constellation-layout__content {
        padding: 1rem !important;
    }
}
`;

const ConstellationLayout: React.FC<Props> = ({ children }) => {
    const { t } = useTranslation();
    return (
        <>
            <style>{mediaCss}</style>
            <div className="constellation-layout" style={styles.page}>
                <aside className="constellation-layout__sidebar" style={styles.sidebar}>
                    <img
                        className="constellation-layout__logo"
                        src={logo}
                        alt={t('topheader.logo_alt')}
                        style={styles.logo}
                    />
                    <p className="constellation-layout__tagline" style={styles.tagline}>
                        {t('topheader.tagline')}
                    </p>
                </aside>
                <main className="constellation-layout__content" style={styles.content}>
                    <div style={styles.contentInner}>{children}</div>
                </main>
            </div>
        </>
    );
};

export default ConstellationLayout;
